import React from 'react';
import PropTypes from 'prop-types';
import {
  ElementsProjects,
  StyledBoxImage,
  StyledContent,
  StyledTitle,
  StyledParagraph,
  StyledViewProjects,
  StyledPlus,
  StyledImage
} from './style';

import { PANORAMA_SMALL_MEDIUM } from '../../../utils/crops';

import { Plus } from '../../../../assets/images/index';

const ItemsProjects = ({ className, title, text, imgSrc }) => (
  <ElementsProjects className={className}>
    <StyledBoxImage>
      <StyledImage
        path={imgSrc}
        defaultCrop={PANORAMA_SMALL_MEDIUM}
        alt={title}
        crops={[
          {
            media: '(min-width: 720px)',
            crop: { height: 135, width: 360 }
          }
        ]}
      />
    </StyledBoxImage>
    <StyledContent>
      <StyledTitle>{title}</StyledTitle>
      <StyledParagraph maxlength={107} text={text} />
      <StyledViewProjects>
        <StyledPlus color="primary" size="s" svg={Plus} />
        Ver Proyecto
      </StyledViewProjects>
    </StyledContent>
  </ElementsProjects>
);

ItemsProjects.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  imgSrc: PropTypes.string
};

export default ItemsProjects;
